<template>
  <aside class="main-sidebar">
    <div class="sidebar">
      <div class="logo mt-3 mb-3 ml-3">
        <img :src="iconUrl" alt="">
      </div>
      <ul v-if="isAdmin == true" class="sidebar-menu text-left">
        <li class="header"></li>
        <li class="treeview">
          <a href="#" v-on:click="adminHome">
            <b-icon-house-door font-scale="1.5" class="sidebar-icon"></b-icon-house-door><span>Home</span>
          </a>
          <a href="#" v-on:click="go('/admin/analytics')">
            <b-icon-bar-chart font-scale="1.5" class="sidebar-icon"></b-icon-bar-chart><span>Analytics</span>
          </a>
          <!-- <a href="#" v-on:click="go('/admin/tasks')">
            <b-icon-list-check font-scale="1.5" class="sidebar-icon"></b-icon-list-check><span>Tasks</span>
          </a> -->
        </li>
        <!--<li class="treeview">
          <a href="#" v-on:click="keywords">
            <i class="icon icon icon-file-key2 yellow-text s-18"></i>
            <span class="badge r-3 badge-success pull-right">20</span>
            <span>Keywords</span>
          </a>
        </li>-->
        <li class="header light mt-3"><strong>Profile</strong></li>
        <li class="treeview ">
          <a href="#" v-on:click="profile">
            <b-icon-person font-scale="1.7" class="sidebar-icon"></b-icon-person><span>Profile</span>
          </a>
        </li>
        <li class="treeview">
          <a href="#" v-on:click="signOut">
            <b-icon-power font-scale="1.5" class="sidebar-icon red-text"></b-icon-power><span>Log Out</span>
          </a>
        </li>
      </ul>
      <ul v-else class="sidebar-menu text-left">
        <li class="header"></li>
        <li class="treeview">
          <a href="#" v-on:click="home">
            <b-icon-house-door font-scale="1.5" class="sidebar-icon"></b-icon-house-door><span>Home</span>
          </a>
        </li>
        <li class="treeview">
          <a href="#" v-if="isAdmin == true" v-on:click="campaigns">
            <i class="icon icon icon-send2  s-18"></i>
            <!--<span class="badge r-3 badge-success pull-right">20</span>-->
            <span>Campaigns</span>
          </a>
        </li>
        <!--<li class="treeview">
          <a href="#" v-on:click="keywords">
            <i class="icon icon icon-file-key2 yellow-text s-18"></i>
            <span class="badge r-3 badge-success pull-right">20</span>
            <span>Keywords</span>
          </a>
        </li>-->
        <li class="treeview">
          <a href="#" v-if="isAdmin == true" v-on:click="lists">
            <b-icon-bullseye font-scale="1.5" class="sidebar-icon"></b-icon-bullseye>
            <span>Goals</span>
          </a>
        </li>
        <template v-if="isAdmin == true">
          <li class="header light mt-3"><strong>Your Organization</strong></li>
          <li class="treeview">
            <a href="#" v-on:click="users">
              <b-icon-people font-scale="1.5" class="sidebar-icon"></b-icon-people>
              <span>Manage Users</span>
            </a>
          </li>
        </template>
        <li class="header light mt-3"><strong>Account</strong></li>
        <li class="treeview ">
          <a href="#" v-on:click="profile">
            <b-icon-person font-scale="1.7" class="sidebar-icon"></b-icon-person><span>Profile</span>
          </a>
        </li>
        <!-- <li class="treeview ">
          <a href="#" v-on:click="settings">
            <b-icon-gear font-scale="1.5" class="sidebar-icon"></b-icon-gear><span>Settings</span>
          </a>
        </li> -->
        <!-- <li class="treeview">
          <a href="#" target="_blank">
            <b-icon-question-circle font-scale="1.5" class="sidebar-icon"></b-icon-question-circle><span>Help</span>
          </a>
        </li> -->
        <li class="treeview">
          <a href="#" v-on:click="signOut">
            <b-icon-power font-scale="1.5" class="sidebar-icon red-text"></b-icon-power><span>Log Out</span>
          </a>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
  import Vue from 'vue'
  import { Auth } from 'aws-amplify'
  import { IconsPlugin } from 'bootstrap-vue'
  import axios from 'axios'
  import Constants from '../../Constants'
  Vue.use(IconsPlugin)

  export default {
    name: "Sidebar",
    data() {
      return { 
        isAdmin: false
      }
    },
    computed: {
      iconUrl() {
        return require('../../../static/img/basic/boom_logo.png')
      }
    },
    methods: {
      go(path) {
        this.$router.push(path)
      },
      adminHome: function () {
        this.$router.push('/admin')
      },
      home: function () {
        this.$router.push('/')
      },
      inbox: function () {
        this.$router.push('/inbox')
      },
      subscribers: function () {
        this.$router.push('/subscribers')
      },
      users: function () {
        this.$router.push('/users')
      },
      campaigns: function () {
        this.$router.push('/campaigns')
      },
      keywords: function () {
        this.$router.push('/key-words')
      },
      lists: function () {
        this.$router.push('/goals')
      },
      profile: function () {
        this.$router.push('/profile')
      },
      settings: function() {
        this.$router.push('/settings')
      },
      async signOut() {
        await Auth.signOut()
        window.location.href = '/'
      },
    },
    mounted() {
      Auth.currentAuthenticatedUser()
        .then(user => {
          user.signInUserSession.accessToken.payload['cognito:groups'].forEach(role => {
            if (role == "admin" || role == "owner") { 
              this.isAdmin = true 
            }
          })
        }).catch(err => {
          console.log(err)
        })
    }
  }
</script>

<style scoped>
  .main-sidebar {
    z-index: 9;
    width: 100%;
  }

  .sidebar {
    width: 100%;
    min-height: 100%;
    background: #fff;
  }

  .sidebar-icon {
    margin-right: 16px;
    color: #2F4F4F;
  }

  .inbox-badge {
    margin-left: 8px;
    padding-top: 4px;
    padding-bottom: 4px;
    text-align: center; 
  }

  .treeview a span {
    font-size: 14px;
    color: #2F4F4F;
  }

  @media (max-width: 1025px) {
    .main-sidebar,
    .left-side {
      -webkit-transform: translate(0, 0);
      -ms-transform: translate(0, 0);
      -o-transform: translate(0, 0);
      transform: translate(0, 0);
    }
  }

  .logo {
    max-width: 140px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Sidebar.vue